export function openFileDownloadLink(link: string, title?: string) {
  const a = document.createElement('a');
  a.href = link;
  a.download = title || '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
